import { useMemo } from 'react';
import { authService } from '@/domains/internal/auth/services/authService';

/**
 * Custom hook for accessing authentication state and utilities
 */
export const useAuth = () => {
  const user = authService.getUser();
  const isAuthenticated = authService.isAuthenticated();

  return useMemo(
    () => ({
      user,
      isAuthenticated,

      // Role checks
      hasRole: (roleType: string) => authService.hasRole(roleType),
      hasAnyRole: (roleTypes: string[]) => authService.hasAnyRole(roleTypes),
      getRoles: () => authService.getRoles(),

      // Permission checks
      hasPermission: (permission: string) => authService.hasPermission(permission),
      hasAnyPermission: (permissions: string[]) => authService.hasAnyPermission(permissions),
      getPermissions: () => authService.getPermissions(),

      // Feature checks
      canManagePatients: () => authService.canManagePatients(),
      canManageQueue: () => authService.canManageQueue(),
      canProcessPayments: () => authService.canProcessPayments(),
      canViewReports: () => authService.canViewReports(),
      canManageStaff: () => authService.canManageStaff(),
      canManageRoles: () => authService.canManageRoles(),

      // Role type checks
      isSuperAdmin: () => authService.isSuperAdmin(),
      isAdmin: () => authService.isAdmin(),

      // Department
      getDepartment: () => authService.getDepartment(),

      // Auth actions
      logout: () => authService.logout(),
    }),
    [user, isAuthenticated]
  );
};

export default useAuth;
